// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 512) return "static/css/512.f94c9d593.chunk.css";
	if (chunkId === 874) return "static/css/874.f94c9d593.chunk.css";
	// return url for filenames based on template
	return undefined;
};